import { Drawer } from "antd";

import MenuItems from "./MenuItems";
import TopNavbar from "@/common/organisms/Navbar/TopNavbar";
import "./Navbar.css";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "@/features/auth/duck/auth";
import { userReset } from "@/features/user/duck/user";
import { useState } from "react";
import MobileNavOthersSection from "./MobileNavOthersSection";
import { resetAiChatBot } from "@/features/aiAgentChatBot/duck/aiChatBot";

const MobileMenu = ({
  nav,
  onClose,
  isLogin,
  userInfo,
  isMobile,
  handleClick
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [visible, setVisibility] = useState(false);

  const onLogoutHandler = () => {
    dispatch(logout());
    setVisibility(!visible);
    dispatch(userReset());
    navigate("/");
    dispatch(resetAiChatBot());
  };

  return (
    <Drawer
      placement={"left"}
      closable={true}
      onClose={onClose}
      open={nav}
      className="home-mobile-menu"
      key={"left"}>
      <div className="p-0">
        <TopNavbar isMobile={isMobile} />
      </div>
      <div className="flex flex-col w-full gap-2 mt-6">
        <div className="absolute top-[120px] ltr:-left-10 rtl:-right-10 w-7/12 h-16 bg-[#90B393] opacity-20 blur-xl"></div>

        <MenuItems
          handleNav={onClose}
          isLogin={isLogin}
          userInfo={userInfo}
          isMobile={isMobile}
          handleClick={handleClick}
        />

        <MobileNavOthersSection
          isLogin={isLogin}
          isMobile={isMobile}
          onLogoutHandler={onLogoutHandler}
        />
      </div>
    </Drawer>
  );
};

export default MobileMenu;
